<div class="bc-page">

  <!-- ============================================================
       HERO — Summer Beach (same as summer course)
       ============================================================ -->
  <section class="bc-hero">

    <div class="bc-sun"></div>
    <div class="bc-sun-rays"></div>

    <div class="bc-cloud bc-cloud-1"></div>
    <div class="bc-cloud bc-cloud-2"></div>
    <div class="bc-cloud bc-cloud-3"></div>

    <div class="bc-ocean">
      <div class="bc-wave bc-wave-1"></div>
      <div class="bc-wave bc-wave-2"></div>
      <div class="bc-wave bc-wave-3"></div>
    </div>

    <div class="bc-beach"></div>

    <!-- Left palm -->
    <div class="bc-palm-wrap bc-palm-left">
      <svg class="bc-palm-svg" viewBox="0 0 180 280" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M90 280 C85 240 78 200 82 160 C86 120 90 100 88 70" stroke="#8B5E3C" stroke-width="14" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C60 55 30 40 10 20" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C80 45 75 20 80 0"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C110 55 140 45 160 30" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C95 50 110 30 120 10"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C70 60 50 65 30 70"    stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C105 65 130 70 155 60"  stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <circle cx="85" cy="72" r="7" fill="#C49020"/>
        <circle cx="94" cy="68" r="6" fill="#C49020"/>
      </svg>
    </div>

    <!-- Right palm -->
    <div class="bc-palm-wrap bc-palm-right">
      <svg class="bc-palm-svg" viewBox="0 0 180 280" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M90 280 C95 240 100 200 96 160 C92 120 88 100 92 70" stroke="#8B5E3C" stroke-width="14" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C120 55 150 40 170 20" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C100 45 105 20 100 0"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C70 55 40 45 20 30" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C85 50 70 30 60 10"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C110 60 130 65 150 70"  stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C75 65 50 70 25 60"    stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <circle cx="95" cy="72" r="7" fill="#C49020"/>
        <circle cx="86" cy="68" r="6" fill="#C49020"/>
      </svg>
    </div>

    <!-- Hero content -->
    <div class="bc-container">
      <div class="bc-hero-content">

        <div class="bc-hero-brand">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
          SEHYOG ACADEMY
        </div>

        <div class="bc-hero-pill">11+ Bootcamp</div>

        <h1 class="bc-hero-title"><em>SUMMER</em><br>BOOTCAMP</h1>

        <div class="bc-hero-subtitle">Subject-Specific · Focused Revision</div>

        <div class="bc-boards-row">
          <div class="bc-boards-strip">
            <span class="bc-board-item">CSSE</span>
            <span class="bc-board-item">GL</span>
            <span class="bc-board-item">FSCE</span>
            <span class="bc-board-item">SET</span>
            <span class="bc-board-item">ISEB</span>
          </div>
          <div class="bc-board-date">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="vertical-align:middle;margin-right:4px"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            FROM 19 JULY
          </div>
        </div>

        <div class="bc-hero-actions">
          <button class="bc-btn-book" (click)="scrollToBook()">
            Book Now
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <button class="bc-btn-outline" (click)="downloadBrochure()">
            Download Brochure
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </button>
        </div>

        <div class="bc-early-bird">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          EARLY BIRD DISCOUNT — VALID TILL PLACES FILL UP!
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       STATS STRIP
       ============================================================ -->
  <div class="bc-stats-strip">
    <div class="bc-container">
      <div class="bc-stats-inner">
        <div class="bc-stat">
          <span class="bc-stat-num">4</span>
          <span class="bc-stat-label">Subjects Covered</span>
        </div>
        <div class="bc-stat">
          <span class="bc-stat-num">12 hrs</span>
          <span class="bc-stat-label">Expert Tuition</span>
        </div>
        <div class="bc-stat">
          <span class="bc-stat-num">720+</span>
          <span class="bc-stat-label">Exam Questions</span>
        </div>
        <div class="bc-stat">
          <span class="bc-stat-num">2</span>
          <span class="bc-stat-label">F2F Mock Exams</span>
        </div>
        <div class="bc-stat">
          <span class="bc-stat-num">8 days</span>
          <span class="bc-stat-label">Per Subject</span>
        </div>
      </div>
    </div>
  </div>

  <!-- ============================================================
       SUBJECTS BREAKDOWN
       ============================================================ -->
  <section class="bc-subjects-section">
    <div class="bc-container">

      <div class="bc-section-header bc-reveal bc-hidden">
        <p class="bc-eyebrow">What You'll Study</p>
        <h2 class="bc-section-title">Subject-Specific <span>Bootcamps</span></h2>
        <p class="bc-section-sub">Ideal for focused revision — tackle each subject in depth over 8 days</p>
      </div>

      <div class="bc-subjects-grid">

        <div class="bc-subject-card bc-reveal bc-hidden">
          <div class="bc-subject-icon">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
          </div>
          <div class="bc-subject-info">
            <h3 class="bc-subject-name">Maths</h3>
            <p class="bc-subject-desc">Number, algebra, data, shape &amp; problem-solving in exam format</p>
          </div>
          <div class="bc-subject-badge">
            <span class="bc-badge-num">12 sessions</span>
            <span class="bc-badge-days">/ 8 Days</span>
          </div>
        </div>

        <div class="bc-subject-card bc-reveal bc-hidden bc-d1">
          <div class="bc-subject-icon bc-icon-gold">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
          </div>
          <div class="bc-subject-info">
            <h3 class="bc-subject-name">English</h3>
            <p class="bc-subject-desc">Creative writing &amp; comprehension — structure, vocabulary and technique</p>
          </div>
          <div class="bc-subject-badge">
            <span class="bc-badge-num">12 sessions</span>
            <span class="bc-badge-days">/ 8 Days</span>
          </div>
        </div>

        <div class="bc-subject-card bc-reveal bc-hidden bc-d2">
          <div class="bc-subject-icon bc-icon-cyan">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
          </div>
          <div class="bc-subject-info">
            <h3 class="bc-subject-name">Verbal Reasoning (VR)</h3>
            <p class="bc-subject-desc">Word patterns, codes, analogies and all GL/CSSE VR question types</p>
          </div>
          <div class="bc-subject-badge">
            <span class="bc-badge-num">12 sessions</span>
            <span class="bc-badge-days">/ 8 Days</span>
          </div>
        </div>

        <div class="bc-subject-card bc-reveal bc-hidden bc-d3">
          <div class="bc-subject-icon bc-icon-green">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>
          </div>
          <div class="bc-subject-info">
            <h3 class="bc-subject-name">Non-Verbal Reasoning (NVR)</h3>
            <p class="bc-subject-desc">Patterns, sequences, matrices and spatial reasoning for all formats</p>
          </div>
          <div class="bc-subject-badge">
            <span class="bc-badge-num">12 sessions</span>
            <span class="bc-badge-days">/ 8 Days</span>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       COURSE HIGHLIGHTS
       ============================================================ -->
  <section class="bc-highlights-section">
    <div class="bc-container">

      <div class="bc-section-header bc-reveal bc-hidden">
        <p class="bc-eyebrow">Course Highlights</p>
        <h2 class="bc-section-title">Everything <span>Included</span></h2>
      </div>

      <div class="bc-highlights-grid">

        <div class="bc-highlight-card bc-reveal bc-hidden">
          <div class="bc-hi-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
          </div>
          <div class="bc-hi-num">12 hrs</div>
          <div class="bc-hi-title">Expert-Led Tuition</div>
          <p class="bc-hi-text">Delivered by experienced 11+ tutors who know what the exam boards want.</p>
        </div>

        <div class="bc-highlight-card bc-reveal bc-hidden bc-d1">
          <div class="bc-hi-icon bc-hi-gold">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
          </div>
          <div class="bc-hi-num">720+</div>
          <div class="bc-hi-title">Exam-Style Questions</div>
          <p class="bc-hi-text">12 assignments &amp; 12 practice tests — over 720 questions across all subjects.</p>
        </div>

        <div class="bc-highlight-card bc-reveal bc-hidden bc-d2">
          <div class="bc-hi-icon bc-hi-cyan">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <div class="bc-hi-num">2</div>
          <div class="bc-hi-title">In-Person Mock Exams</div>
          <p class="bc-hi-text">Choose CSSE, FSCE or GL format — papers sat under true exam conditions.</p>
        </div>

        <div class="bc-highlight-card bc-reveal bc-hidden bc-d3">
          <div class="bc-hi-icon bc-hi-green">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
          </div>
          <div class="bc-hi-num">1 PTM</div>
          <div class="bc-hi-title">Parent-Teacher Meeting</div>
          <p class="bc-hi-text">Personalised progress discussion and targeted guidance for each student.</p>
        </div>

        <div class="bc-highlight-card bc-reveal bc-hidden bc-d4">
          <div class="bc-hi-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
          </div>
          <div class="bc-hi-num">150–250</div>
          <div class="bc-hi-title">Cohort RAR Report</div>
          <p class="bc-hi-text">Standard score, rank &amp; percentile benchmarked across the full cohort.</p>
        </div>

        <div class="bc-highlight-card bc-reveal bc-hidden bc-d5">
          <div class="bc-hi-icon bc-hi-gold">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <div class="bc-hi-num">Pre-Lecture</div>
          <div class="bc-hi-title">Materials &amp; Tips</div>
          <p class="bc-hi-text">Summary notes, proven tricks &amp; techniques to decode tough 11+ questions.</p>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       WHAT'S ALSO INCLUDED — full-width feature list
       ============================================================ -->
  <section class="bc-features-section">
    <div class="bc-container">

      <div class="bc-features-inner">
        <div class="bc-features-left bc-reveal bc-hidden">
          <p class="bc-eyebrow">Full Package</p>
          <h2 class="bc-section-title">Supportive <span>Every Step</span></h2>
          <p class="bc-section-sub" style="margin-top:12px">Our dedicated Customer Success Team is here from the moment you book through to results day.</p>
          <div class="bc-features-cta" style="margin-top:32px">
            <button class="bc-btn-primary" (click)="scrollToBook()">
              Book Your Place Now
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </button>
          </div>
        </div>

        <div class="bc-features-right bc-reveal bc-hidden bc-d1">
          <div class="bc-feature-item">
            <div class="bc-feature-icon">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/></svg>
            </div>
            <div>
              <div class="bc-feature-title">Cohort Performance Report (RAR)</div>
              <p class="bc-feature-text">Consolidated Result Analysis across all centres — standard score, rank, percentile and more.</p>
            </div>
          </div>

          <div class="bc-feature-item">
            <div class="bc-feature-icon">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            </div>
            <div>
              <div class="bc-feature-title">True Exam Conditions</div>
              <p class="bc-feature-text">Timed, invigilated sessions that mirror the real 11+ exam day experience.</p>
            </div>
          </div>

          <div class="bc-feature-item">
            <div class="bc-feature-icon">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
            </div>
            <div>
              <div class="bc-feature-title">Personalised Feedback</div>
              <p class="bc-feature-text">Tailored guidance and clear recommendations on specific areas to improve.</p>
            </div>
          </div>

          <div class="bc-feature-item">
            <div class="bc-feature-icon">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/></svg>
            </div>
            <div>
              <div class="bc-feature-title">Take-Home Review Pack</div>
              <p class="bc-feature-text">Papers and full answer keys to take home for continued revision after each session.</p>
            </div>
          </div>

          <div class="bc-feature-item">
            <div class="bc-feature-icon">
              <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/></svg>
            </div>
            <div>
              <div class="bc-feature-title">Ongoing Consultation</div>
              <p class="bc-feature-text">Continuous support throughout the course to track progress and close learning gaps.</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

  <!-- ============================================================
       TESTIMONIAL + CTA
       ============================================================ -->
  <section class="bc-testi-section">
    <div class="bc-container">
      <div class="bc-testi-inner">

        <div class="bc-testi-card bc-reveal bc-hidden">
          <div class="bc-stars">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          </div>
          <p class="bc-testi-text">
            "The mock tests helped us identify exactly which areas needed work. The detailed result analysis gave us a clear picture week by week — my son secured his place at his chosen grammar school!"
          </p>
          <div class="bc-testi-name">Jaya Rani</div>
        </div>

        <div class="bc-testi-right bc-reveal bc-hidden bc-d2">
          <h2 class="bc-testi-heading">Join <em>10,000+</em><br>Successful <span>Students</span></h2>
          <p class="bc-testi-sub">Sehyog has been guiding students to grammar school success since 2014. Our Bootcamp is rated 5 stars on Trustpilot.</p>
          <button class="bc-btn-primary" (click)="scrollToBook()">
            Book Bootcamp Now
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <div style="margin-top:16px">
            <a class="bc-compare-link" [routerLink]="['/rapid-course']">
              Compare with Summer Intensive Course →
            </a>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       CONTACT / BOOK NOW
       ============================================================ -->
  <section class="bc-contact-section" id="book">
    <div class="bc-container">
      <div class="bc-contact-inner">

        <div class="bc-reveal bc-hidden">
          <h2 class="bc-contact-title">Ready to <em>Start This Summer?</em></h2>
          <p class="bc-contact-sub">Secure your child's place on the 11+ Summer Bootcamp. Limited spaces — bookings fill up fast every year.</p>

          <div class="bc-contact-links">
            <a href="tel:+4403980844" class="bc-contact-link">
              <div class="bc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
              </div>
              +44 (0) 3980 8244
            </a>
            <a href="tel:+447464772331" class="bc-contact-link">
              <div class="bc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
              </div>
              +44 7464 772331
            </a>
            <a href="mailto:support@sehyog.co.uk" class="bc-contact-link">
              <div class="bc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </div>
              support@sehyog.co.uk
            </a>
            <a href="https://www.sehyog.co.uk" target="_blank" class="bc-contact-link">
              <div class="bc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              </div>
              www.sehyog.co.uk
            </a>
          </div>

          <div class="bc-social-row">
            <a class="bc-social-btn" href="#" aria-label="LinkedIn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
            <a class="bc-social-btn" href="#" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a class="bc-social-btn" href="#" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19.54C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>
            </a>
            <a class="bc-social-btn" href="#" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
          </div>
        </div>

        <!-- QR + CTA card -->
        <div class="bc-reveal bc-hidden bc-d2">
          <div class="bc-cta-card">
            <div class="bc-cta-card-inner">
              <h3 class="bc-cta-heading">Scan to Book</h3>
              <div class="bc-qr-box">
                <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                  <rect x="5" y="5" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                  <rect x="12" y="12" width="21" height="21" fill="#0B4F6C"/>
                  <rect x="60" y="5" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                  <rect x="67" y="12" width="21" height="21" fill="#0B4F6C"/>
                  <rect x="5" y="60" width="35" height="35" fill="none" stroke="#0B4F6C" stroke-width="3"/>
                  <rect x="12" y="67" width="21" height="21" fill="#0B4F6C"/>
                  <rect x="60" y="55" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="68" y="55" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="76" y="55" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="84" y="55" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="60" y="63" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="76" y="63" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="60" y="71" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="68" y="71" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="84" y="71" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="60" y="79" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="76" y="79" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="60" y="87" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="68" y="87" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="76" y="87" width="7" height="7" fill="#0B4F6C"/>
                  <rect x="84" y="87" width="7" height="7" fill="#0B4F6C"/>
                </svg>
              </div>
              <p class="bc-qr-sub">Scan with your phone camera</p>
              <p class="bc-qr-handle">&#64;SehyogAcademy</p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="bc-container" style="margin-top:36px;text-align:center;position:relative;z-index:1">
      <p style="font-size:12px;color:rgba(255,255,255,.3);font-weight:600">* T&amp;C applies. All session counts are approximate and subject to scheduling. Early bird discount valid while places last.</p>
    </div>
  </section>

</div>